import angular from 'angular';
import template from './activar.component.html';
import './activar.repository.js';

angular
    .module('Toke')
    .component('appActivar', {
        template,
        bindings: {
            data: '<'
        },
        controller: ActivarController
    });

ActivarController.$inject = ['activarRepository', '$scope'];




function ActivarController(activarRepository, $scope) {
    const vm = this;

    vm.activarData = {};
    vm.activeTab = null;
    vm.isMobile = false;

    vm.$onInit = function () {

        // Detectar tamaño inicial
        vm.isMobile = window.innerWidth < 992;

        // Escuchar resize
        angular.element(window).on('resize', handleResize);

        if (vm.data) {
            init(vm.data);
        } else {
            activarRepository.getActivar().then(res => {
                init(res);
            });
        }
    };


    function init(data) {
        vm.activarData = data;

        if (vm.activarData.tabs?.length) {
            vm.activeTab = vm.activarData.tabs[0];
        }
    }


    function handleResize() {
        $scope.$applyAsync(() => {
            vm.isMobile = window.innerWidth < 992;
        });
    }


    vm.getBackground = function (step) {
        if (!step?.background) return '';

        return vm.isMobile
            ? step.background.mobile
            : step.background.desktop;
    };


    vm.selectTab = function (tab) {

        if (!vm.activeTab || vm.activeTab.id === tab.id) return;

        const $content = angular.element(
            document.querySelector('.js-activar-content')
        );

        if (!$content.length) {
            vm.activeTab = tab;
            return;
        }

        $content.fadeOut(150, function () {

            $scope.$applyAsync(() => {
                vm.activeTab = tab;
            });

            $content.fadeIn(200);
        });
    };



    vm.$onDestroy = function () {
        angular.element(window).off('resize', handleResize);
    };

}

